import React from "react";
import { Card } from "antd";
import Title from "antd/es/typography/Title";

interface CustomCardProps {
  heading: string;
  subHeading?: string;
  children?: React.ReactNode;
}

const CustomCard: React.FC<CustomCardProps> = React.memo(
  ({ heading, subHeading, children }) => {
    return (
      <Card
        style={{
          backgroundColor: "#FFFFFF",
          borderRadius: 20,
          border: "none",
          boxShadow: "none",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Title
            level={5}
            style={{
              margin: 0,
              color: "#1F5782",
              textTransform: "uppercase",
              fontWeight: 400,
            }}
          >
            <span style={{ fontWeight: 700 }}>{heading}</span>{" "}
            <span style={{ fontWeight: 400 }}>{subHeading}</span>
          </Title>
        </div>

        {children && <div style={{ marginTop: "12px" }}>{children}</div>}
      </Card>
    );
  }
);

export default CustomCard;
